import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  question: null,
  allQuestions: [],
  allActiveQuestions: [],
  totalPages: 0,
  totalRecords: 0,
  errorStatus: null,
};
const getters = {
  getApiLoad_123: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_questions(state, questions) {
    state.questions = questions.items;
    state.totalPages = questions.totalPages;
    state.totalRecords = questions?.totalRecords ?? 0;
  },
  SET_AllActiveQuestions(state, activeQuestions) {
    state.allActiveQuestions = activeQuestions;
  },

  SET_AllQuestions(state, questions) {
    state.allQuestions = questions;
  },
  SET_Question(state, question) {
    state.question = question;
  },
};
const actions = {
  errorQuestion({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllQuestions({ commit, dispatch, rootState }, chiefComplaintId) {
    let url = '/ChiefComplaintTriageQuestions/All?ChiefComplaintId=' + chiefComplaintId;
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_AllQuestions', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorQuestion', error);
      });
  },
  getAllActiveQuestions({ commit, dispatch, rootState }, id) {
    const params = {
      ChiefComplaintId: id,
    };
    return apiClient
      .get('/ChiefComplaintTriageQuestions/AllActive', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllActiveQuestions', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorQuestion', error);
      });
  },
  createQuestion({ commit, dispatch, rootState }, body) {
    return apiClient
      .post('/ChiefComplaintTriageQuestions', body, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorQuestion', error);
      });
  },
  getQuestion({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/ChiefComplaintTriageQuestions/ById', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Question', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorQuestion', error);
      });
  },
  editQuestion({ commit, dispatch, rootState }, body) {
    return apiClient
      .post('/ChiefComplaintTriageQuestions/Edit', body, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorQuestion', error);
      });
  },
  deleteQuestion({ commit, dispatch, rootState }, params) {
    return apiClient
      .post('/ChiefComplaintTriageQuestions/Remove', null, {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorQuestion', error);
      });
  },
  activeQuestion({ commit, dispatch, rootState }, params) {
    return apiClient
      .post('/ChiefComplaintTriageQuestions/Activate', null, {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorQuestion', error);
      });
  },
  deactiveQuestion({ commit, dispatch, rootState }, params) {
    return apiClient
      .post('/ChiefComplaintTriageQuestions/Deactivate', null, {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorQuestion', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
